import React from 'react';

import './styles.scss';

export default function LinechartReadout({ value }) {
  return <p className="linechart-readout">{value}</p>;
}
